<div class="filters">
    <div class="search-container">
        <form [formGroup]="searchForm">
            <app-basic-input
                [icons]="'i-search'"
                [inputConfig]="{
                    placeholder: 'REPERTOIRE.FORMS.USERS.PLACEHOLDERS.SEARCH-FIELD' | translate,
                    inputId: 'search',
                    type: basicInputTypeEnum.TEXT
                }"
                formControlName="searchValue"
            >
            </app-basic-input>
            <a
                aria-controls="repertoire filter"
                aria-expanded="true"
                class="horizontal collapsible-container"
                data-bs-toggle="collapse"
                href="#filter"
                role="button"
                (click)="showFilters = true"
            >
                <span class="icon i-filter"></span>
            </a>
            <button
                *ngIf="searchValue.value"
                class="close-filter icon i-close"
                [title]="'SHARED.FILTERS.REINIT' | translate"
                (click)="resetSearch()"
            ></button>
        </form>
    </div>
    <div class="collapse filters_inner" id="filter" [ngClass]="{ show: showFilters }">
        <div class="filters_title-container">
            <h4 class="filters_title">{{ 'REPERTOIRE.CONTACTS.FILTERS.TITLE' | translate }}</h4>
            <button class="close-filter" data-bs-target="#filter" data-bs-toggle="collapse"></button>
        </div>

        <div class="input-container card">
            <h5 class="filters_label">{{ 'REPERTOIRE.FORMS.EDUCATION-LEVEL.TITLE' | translate }}</h5>
            <app-generic-radio-checkbox
                [config]="{
                    formGroupName: 'educationLevel',
                    inputType: 'checkbox',
                    questionChoices: educationLevels$ | async
                }"
                [formControl]="educationLevel"
            >
            </app-generic-radio-checkbox>
        </div>

        <div class="input-container card">
            <h5 class="filters_label">{{ 'REPERTOIRE.FORMS.ROLES.TITLE' | translate }}</h5>
            <app-generic-radio-checkbox
                [config]="{
                    formGroupName: 'roles',
                    inputType: 'checkbox',
                    questionChoices: entityTypesChoices
                }"
                [formControl]="entitiesTypes"
            >
            </app-generic-radio-checkbox>
        </div>

        <div class="input-container card">
            <h5 class="filters_label">{{ 'REPERTOIRE.FORMS.STATUS.TITLE' | translate }}</h5>
            <app-generic-radio-checkbox
                [config]="{
                    formGroupName: 'entitiesStatus',
                    inputType: 'checkbox',
                    questionChoices: entityStatusChoices
                }"
                [formControl]="entitiesTypes"
            >
            </app-generic-radio-checkbox>
        </div>
        <app-generic-button
            [inputText]="'REPERTOIRE.CONTACTS.FILTERS.APPLY-BTN'"
            [classes]="'btn btn--primary'"
            (buttonClick)="applyFilters()"
        ></app-generic-button>
        <app-generic-button
            [inputText]="'REPERTOIRE.CONTACTS.FILTERS.RESET-BTN'"
            [classes]="'btn btn--secondary'"
            (buttonClick)="resetFilters()"
        ></app-generic-button>
    </div>
</div>
